import React, { useState } from 'react'
import { useForm, FormContext } from 'react-hook-form'
import PropTypes from 'prop-types'
import {
  Box,
  Button,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core'
import ImportEmailsDialog from '../ImportEmailsDialog'

import { isEmpty } from 'lodash'

import { TextFieldList } from 'components'

import helpers from 'helpers'

import useClipboard from 'hooks/useClipboard'
import useSnackbar from 'hooks/useSnackbar'

import constants from 'constants/index'
import { getBaseURL } from 'service/env'
import * as service from 'service'
import schema from './schema'
import theme from 'theme'

import styles from './styles'

const ConsentDetailsPublishSection = ({ consentForm, setLoading }) => {
  const snackbar = useSnackbar()
  const { copy } = useClipboard()
  const [openImportDialog, setOpenImportDialog] = useState(false)

  const formMethods = useForm({
    validationSchema: schema,
    defaultValues: {
      email: '',
      emailList: [],
    },
  })

  const { errors, reset, handleSubmit, watch } = formMethods

  const useStyles = styles(errors)
  const classes = useStyles()
  const portalURL = getBaseURL('privacyPortal')

  const url = `${portalURL}/consent-forms?token=${consentForm?.token}`

  const emailList = watch('emailList')

  const handleCopyContent = () => copy(url)

  const onSubmit = async (data) => {
    try {
      setLoading(true)

      await service.dponet.consent.sendLink({
        token: consentForm?.token,
        email: data.emailList,
      })

      snackbar.open({
        message: 'Formulário compartilhado com sucesso!',
        variant: 'success',
      })
      reset()
    } catch (error) {
      console.error(error)
      snackbar.open({
        message: helpers.formatters.errorMessage(error.response.data.error),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  const handleOpenImportDialog = () =>
    setOpenImportDialog((prevOpen) => !prevOpen)

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        gridGap={theme.spacing(3)}
        id={constants.consent.DETAILS_DRIVER_STEP_2}
      >
        <Box>
          <Typography variant="h4">Publicar Formulário</Typography>
          <Typography variant="caption" color="secondary">
            Torne o seu formulário público, compartilhando o endereço eletrônico
            do formulário com os titulares de dados.
          </Typography>
        </Box>
        <TextField
          fullWidth
          label="Link para o formulário"
          value={url}
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleCopyContent}
                  className={classes.button}
                >
                  Copiar
                </Button>
              </InputAdornment>
            ),
          }}
        />
        <Box className={classes.container}>
          <Box>
            <Typography variant="h6">Compartilhar por e-mail</Typography>
            <Typography>
              Indique um e-mail para receber um link para o formulário, podendo
              ser compartilhado com os titulares de dados
            </Typography>
          </Box>

          <Box>
            <Tooltip title="Importar e-mails de uma planilha (CSV ou XLSX)">
              <Button
                variant="contained"
                color="primary"
                onClick={handleOpenImportDialog}
              >
                Importar
              </Button>
            </Tooltip>
          </Box>
        </Box>
      </Box>
      <ImportEmailsDialog
        open={openImportDialog}
        setOpen={setOpenImportDialog}
        token={consentForm?.token}
      />
      <FormContext {...formMethods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <TextFieldList
            label="Adicionar e-mail"
            controlName="email"
            arrayControlName="emailList"
            containerTitle="E-mails adicionados"
          />

          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={isEmpty(emailList)}
            >
              Enviar
            </Button>
          </Box>
        </form>
      </FormContext>
    </>
  )
}

ConsentDetailsPublishSection.propTypes = {
  setLoading: PropTypes.func.isRequired,
  consentForm: PropTypes.object,
}

export default ConsentDetailsPublishSection
